export default __webpack_public_path__ + "static/media/listStyle.de52526b.PNG";